module.exports = {
  "country": "UA",
  "artist": "Ani Lorak",
  "song": "Shady Lady",
  "year": "2008",
  "place": "2",
  "spotify": "0DHet9TdSsdouIbOjvLf3m"
};